<template>
    <div>
        <PageHeader :page_title="page_title"/>
        <pSpinner v-if="loading"></pSpinner>
        <template v-if="!loading">
        
        <!--<v-container fluid>-->
      
        <v-form ref="form">
          <v-container fluid class="mb-1">
            <v-layout row wrap>
              <template>
                
                <v-flex xs12 sm12 md6>
                  <v-card class="mx-auto">
                  <v-card-text class="text-xs-left">
                      <v-btn color="primary" style="float:right;" small dark v-on:click="show_deposit_list()">
                      View All
                      <v-icon>arrow_forward</v-icon>
                      </v-btn>
                      <span  style="font-size:21px;color:#424242;" class="text-xs-center">Deposit Balance</span><br>
                      <span  style="font-size:13px;color:#616161;" class="text-xs-center">including principle & interest</span><br>
                      <br><br>
                      <span class="text-xs-center" :style="deposit_amount_font_size">₹{{ deposit_amount_total }}</span>
                      <br>
                      &nbsp;<span class="font-weight-light text-xs-center" style="font-size:12px;color:#424242;">as on {{ today_date }}</span>
                    </v-card-text>
                  </v-card>
                </v-flex>
                
                <v-flex xs12 sm12 md6>
                  <v-card class="mx-auto">
                  <v-card-text class="text-xs-left">
                      <v-btn color="primary" style="float:right;" small dark v-on:click="show_loan_list()">
                      View All
                      <v-icon>arrow_forward</v-icon>
                      </v-btn>
                      <span  style="font-size:21px;color:#424242;" class="text-xs-center">Loan Outstanding</span><br>
                      <span  style="font-size:13px;color:#616161;" class="text-xs-center">including principle & interest</span><br>
                      <br><br>
                      <span class="text-xs-center red--text" :style="loan_amount_font_size">₹{{ loan_outstandint_total }}</span>
                      <br>
                      &nbsp;<span class="font-weight-light text-xs-center" style="font-size:12px;color:#424242;">as on {{ today_date }}</span>
                    </v-card-text>
                  </v-card>
                </v-flex>
                
                <v-flex xs12 sm12 md6 v-if="d_l_due_array.length">
                <v-card>
                  <v-list two-line>
                    <template v-for="(item, index) in d_l_due_array">
                      <v-subheader
                        v-if="item.header"
                        :key="item.header"
                      >
                        <span  style="font-size:21px;color:#424242;" class="text-xs-center">{{ item.header }}</span>
                      </v-subheader>
                      
                      <v-divider
                        v-else-if="item.divider"
                        :inset="item.inset"
                      ></v-divider>
                      
                      <v-list-tile
                      v-else-if="item.no_dues"
                      >
                      <v-list-tile-content>
                        <v-list-tile-sub-title>
                          <span>{{ item.no_dues }}</span>
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                      </v-list-tile>
          
                      <v-list-tile
                        v-else
                        :key="item.rb_account_id"
                        avatar
                        @click="goto_acc_details_page(item.rb_account_id, item.product_id)"
                      >
                        <v-list-tile-avatar color="primary">
                             <span class="white--text headline">{{ item.product_name[0] }}</span>
                        </v-list-tile-avatar>
          
                        <v-list-tile-content>
                          <v-list-tile-title>
                            <span style="font-size: 22px;font-weight: bold;">₹ {{ item.due_amount }}</span>
                            <span style="font-size: 15px;float:right" v-if="item.due_date"> Due On {{ item.due_date }}</span>
                          </v-list-tile-title>
                          <v-list-tile-sub-title>
                            <span>{{ item.product_name }}</span>
                            <!--<span style="font-size: 12px;" v-if="item.due_date"> Due On {{ item.due_date }}</span>-->
                            <span style="color: #bd2562d9;font-size: 16px;float:right;">{{ item.custom_id }}</span>
                          </v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </template>
                  </v-list>
                </v-card>
              </v-flex>
              </template>  
            </v-layout>
            </v-container>
            </v-form>
            
        <!--</v-container>-->
        </template>
    </div>

</template>

<style type="text/css">
  
  .go_to {
    
    color:grey;
    float:right;
    height: 32px;
    background: transparent !important;
    border: 1px solid grey;
    align-items: center;
    border-radius: 28px;
    font-size: 13px;
    margin: 4px;
    justify-content: space-between;
    padding: 5px 12px;
    vertical-align: middle;
    white-space: nowrap;
    z-index: 1;
    
    
  }
  
  .go_to:hover {
    color:#bd2562;
    cursor:pointer;
    border: 1px solid #bd2562;
    
  }
  
</style>

<script>

  import axios from 'axios'

  import NoData from '@/components/NoData'
  
  import PageHeader from '@/components/PageHeader'

  import global from '@/components/rbconstants';
  
  import DepositMeta from '@/components/DepositMeta';
  
  import pSpinner from '@/components/pSpinner';

  export default {

    components : {

        NoData : NoData,
        
        PageHeader : PageHeader,
        
        DepositMeta : DepositMeta,
        
        pSpinner : pSpinner,
        

    },  
   
    mounted() {
        var user_details = localStorage.getItem('user');
        user_details = JSON.parse(user_details);
        user_details = user_details[0];
        this.user_name = user_details.firstname+' '+user_details.lastname;
        this.deposit_amount_font_size = this.deposit_amount_font_size_org;
        this.loan_amount_font_size = this.loan_amount_font_size_org;
        this.getDataFromApi()
        .then(data => {
          this.deposit_amount_total = data.dashboard_data.deposit_amount_total;
          this.loan_outstandint_total = data.dashboard_data.loan_outstandint_total;
          this.loan_amount_due_array = data.dashboard_data.loan_amount_due_array;
          this.d_l_due_array = data.dashboard_data.d_l_due_array;
          this.page_title = data.dashboard_data.greeting;
          this.today_date = data.dashboard_data.date;
          this.loading = false;
        })
        this.onResize()
        window.addEventListener('resize', this.onResize, { passive: true })
    },
    
    watch : {
      isMobile : function() {
          if(this.isMobile) {
            this.deposit_amount_font_size = 'color:#40ab44;font-weight:bold;font-size:32px;';
            this.loan_amount_font_size = 'font-weight:bold;font-size:32px;';
            } else {
            this.deposit_amount_font_size = this.deposit_amount_font_size_org;
            this.loan_amount_font_size = this.loan_amount_font_size_org;
          }
      },
      beforeDestroy () {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', this.onResize, { passive: true })
      }
      }
    },
      
    data: () => ({
        
        page_title : "",
        
        deposit_list : [],
        
        loading : false,
        
        user_name : '',
        
        deposit_amount_total : 0.00,
        
        loan_outstandint_total : 0.00,
        
        loan_amount_due_array : [],
        
        deposit_amount_font_size : '',
        deposit_amount_font_size_org : 'color:#40ab44;font-weight:bold;font-size:42px;',
        
        loan_amount_font_size : '',
        loan_amount_font_size_org : 'font-weight:bold;font-size:42px;',
        
        isMobile: false,
        
        today_date : '',
        
        items: [
          { header: 'Dues' },
          {
            title: 'Property Loan',
            amount: '₹452.23',
            subtitle: "EKPL23"
          },
          { divider: true, inset: true },
          {
            title: 'Business Loan',
            amount: '₹35,434.23',
            subtitle: "EKBL435"
          },
          { divider: true, inset: true },
          {
            title: 'Gold Loan',
            amount: '₹35,434.23',
            subtitle: "EKGL435"
          },
          { divider: true, inset: true },
          {
            title: 'Recurring Deposit',
            amount: '₹35,434.23',
            subtitle: "EKRD435"
          },
          { divider: true, inset: true },
          {
            title: 'Varing Recurring Deposit',
            amount: '₹35,434.23',
            subtitle: "EKVRD435"
          },
        ],
        
        d_l_due_array : [],
        
        
      
        
    }),
    
	methods : {
	    
        getDataFromApi() {
            
            this.loading = true;
           
            this.table_loading = true
            
                return new Promise((resolve, reject) => {
                 
                  var app = this;
                  
                  var form_post_data = {};
                    
                    axios.get(global.links.dashboard, {
                        
                        params : form_post_data,
                    
                        headers: global.header
                        
                        
                    }) .then(function (response) {
                        
                        if(response.status == 200) {
                            var dashboard_data = response.data.data;
                            setTimeout(() => {
                            app.table_loading = false
                            resolve({
                              dashboard_data
                            })
                          }, 1000)
                            
                        }
                        
                    }) .catch(function (error) {
                        
                        app.loading = false;
                        
                    });
                    
            });
        },
        
        show_deposit_list() {
          
          this.$router.push({ name: 'DepositList'});
          
        },
        
        show_loan_list() {
          
          this.$router.push({ name: 'LoanList'});
          
        },
        
        onResize () {
          
          this.isMobile = window.innerWidth < 600
          
        },
      
      goto_acc_details_page : function(deposit_id, product_id) {
        
        
        if(product_id == 2) {
            
            this.$router.push({ name: 'FixedDeposit', params: { id: deposit_id}});
        }
        
        if(product_id == 1) {
            
            this.$router.push({ name: 'SavingsDeposit', params: { id: deposit_id}});
        }
        
        if(product_id == 3) {
            
            this.$router.push({ name: 'CumulativeDeposit', params: { id: deposit_id}});
        }
        
        if(product_id == 4) {
            
            this.$router.push({ name: 'RecurringDeposit', params: { id: deposit_id}});
        }
        
        if(product_id == 5) {
            
            this.$router.push({ name: 'GoldLoan', params: { id: deposit_id}});
        }
        
         if(product_id == 8) {
            
            this.$router.push({ name: 'FDLoan', params: { id: deposit_id}});
        }
        
        
         if(product_id == 9) {
            
            this.$router.push({ name: 'CDLoan', params: { id: deposit_id}});
        }
        
        
        if(product_id == 11) {
            
            this.$router.push({ name: 'PropertyLoan', params: { id: deposit_id}});
        }
        
        if(product_id == 16) {
            
            this.$router.push({ name: 'BusinessLoan', params: { id: deposit_id}});
        }
                
                
            }, 
       
	},

  }
  
</script>
